export default __webpack_public_path__ + "media/images/cooking-d5ed92847fd4ada1f379f674428e1b09.png";